<template>
  <div class="productList">
    <div class="banner">
      <swiper :options="bannerSwiper">
        <swiper-slide v-for="(item,index) in filterBillboard(this.billboards, $i18n.locale)" data-index="index" :key="index">
          <div v-if="item.URL"><a :href="item.URL"><img class='swiImg' :src='item.Image'/></a></div>
          <div v-else><img class='swiImg' :src='item.Image'/></div>
        </swiper-slide>
      </swiper>
      <div class="banner-button-prev"></div>
      <div class="banner-button-next"></div>
    </div>
    <div class="category-buttons">
      <ul>
        <li v-for="(item, index) in groups" :key="index">
          <div class="group-button-container">
            <div class="image-placeholder" @click="navGo(item.ProductGroup_id)">
              <img class="button-image" :src="item.Image" alt="">
            </div>
            <p class="group-button-name">{{ item.Name }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="product-listing-container">
      <div class="breadcrumb-container">
        <div class="breadcrumb-fill"></div>
        <el-breadcrumb class="breadcrumb-products" separator="/">
          <el-breadcrumb-item><a class="bread-text">Products</a></el-breadcrumb-item>
          <el-breadcrumb-item><a class="bread-text">{{ this.activeCustomCategory }}</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="product-list-container">
        <div class="category-filter">
          <div :style="{marginBottom: '30px'}">
            <div class="category-header">
              <font-awesome-icon
                icon="chevron-up"
                :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                @click="toggleCustomCategories"
                :class="customCategoriesOpen ? 'rotate' : 'rotate-back'"/>
              <p class="category-title">Hotlists</p>
            </div>
            <!-- <el-checkbox-group v-for="(item,index) in this.$store.state.products.customCategories" v-model="categorySelected" :max="1" v-show="customCategoriesOpen" @change="selectNewCategory(item)">
              <el-checkbox :label="item.Name">{{item.Name}}</el-checkbox>
            </el-checkbox-group> -->
          </div>

          <div class="category-header">
            <font-awesome-icon
              icon="chevron-up"
              :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
              @click="toggleCategories" :class="categoriesOpen ? 'rotate' : 'rotate-back'"/>
            <p class="category-title">Categories</p>
          </div>
          <el-checkbox-group
            v-for="(item,index) in allGroups"
            v-model="categorySelected" v-show="categoriesOpen"
            @change="navGo(item)" :key="index">
            <el-checkbox :label="item.Name">{{ item.Name }}</el-checkbox>
          </el-checkbox-group>

          <div class="price-filter">
            <div class="price-header">
              <div class="price-start">
                <font-awesome-icon 
                  icon="chevron-up"
                  :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                  @click="togglePrice" :class="priceOpen ? 'rotate' : 'rotate-back'"/>
                <p class="category-title">Price</p>
              </div>
              <div class="price-close">
                <font-awesome-icon
                icon="times"
                :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                @click="cleanPrice"/>
              </div>
            </div>
            <el-slider 
              v-show="priceOpen"
              class="slider-settings"
              @change="logThis"
              :format-tooltip="formatToolTip"
              v-model="priceFilter"></el-slider>
          </div>
        </div>
        <div></div>
        <div class="products">
          <ul v-loading="isLoading">
            <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
              <productCard 
                v-if='$i18n.locale=="en"'
                v-bind:img="item.ThumbnailLarge ? item.ThumbnailLarge : item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Name"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:barcode="item.barcode"
              ></productCard>
              <productCard 
                v-if='$i18n.locale=="ch"'
                v-bind:img="item.ThumbnailLarge ? item.ThumbnailLarge : item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Description"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:barcode="item.barcode"
              ></productCard>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <mbHeader v-show="false" @navGo="navGo"></mbHeader>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import {mapActions, mapState, mapMutations} from 'vuex';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
  flyToElement
} from "../store/modules/cart";
import mbHeader from "../components/mobile/mbHeader";

export default {
  name: "productList",
  components: {
    breadcrumb,
    productCard,
    mbHeader,
  },
  props: {
    categoryProp: {type: Object},
    isLoading: {type: Boolean},
    group: {
      type: String,
    },
  },
  data() {
    return {
      scroll: 0,
      path2: this.currentGroup,
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      chgroup: '',
      sonNavList: [],
      option: "",//下拉框选项值
      filterOptions: [
        {
          value: 'new',
          label: 'New',
          disabled: true
        },
        {
          value: 'top',
          label: 'Top',
          disabled: true
        },
        {
          value: 'sale',
          label: 'Sale',
        },
        {
          value: 'low',
          label: 'Price Low to High',
        },
        {
          value: 'high',
          label: 'Price High to Low',
        },
      ],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths: true,
        spaceBetween: 20,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          //when width >= 480
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          //when width >= 640
          990: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
      activeGroup: '',
      filter: '',
      categoriesOpen: true,
      categorySelected: [],
      priceOpen: true,
      priceFilter: 100,
      currentGroupId: '',
      customCategoriesOpen: true,
      activeCustomCategory: '',
    }
  },
  methods: {
    ...mapActions('products', ['fetchCategories', 'fetchProductsWithGroupId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions(['changeNavGoId','changeShowProductsType1','changeShowProductsType2','changeShowProductsType3']),
    isOutOfStock(item) {
      if (item.IsOverSaleable) {
        return false
      }
      return item.InventoryQuantity > 0 ? false : true
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    logThis() {
      this.fetchSelectedGroup(this.currentGroupId, this.priceFilter)

    },
    cleanPrice() {
      this.priceFilter = 100;
      this.fetchSelectedGroup(this.currentGroupId)
    },
    toggleCategories() {
      this.categoriesOpen = !this.categoriesOpen
    },
    togglePrice() {
      this.priceOpen = !this.priceOpen;
    },
    async fetchSelectedCategories(id) {
      //设置仓库id
      let data={
        company_id: 0,
        warehouse_id: 0
      };
      if(this.companyId === 1){
        data.company_id = 1
        data.warehouse_id = 1
      }
      if(this.companyId === 2){
        data.company_id = 2
        data.warehouse_id = 2
      }
      if(this.companyId === 3){
        data.company_id = 3
        data.warehouse_id = 8
      }
      if(this.companyId === 4){
        data.company_id = 4
        data.warehouse_id = 9
      }
      if(this.companyId === 5){
        data.company_id = 5
        data.warehouse_id = 10
      }
      await this.fetchCategories({id,company_id:data.company_id,warehouse_id:data.warehouse_id})
        .then(res => {
          const ctemp1 = [];
          const ctemp2 = [];
          const sortedData = res.data.map((a) => {
            if (this.isOutOfStock(a)) {
              ctemp2.push(a)
            } else {
              ctemp1.push(a)
            }
          })
          this.catOut = ctemp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.catReg = ctemp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          })
          this.list = this.catReg.concat(this.catOut);
        })
        .catch(err => {
          console.log('err fetching product', err);
        })
    },
    formatToolTip(val) {
      return '$' + val;
    },
    priceStuff() {
      return 'color: red';
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    navGo(item) {
      //保存id
      this.changeNavGoId(item);
      //保存显示产品的类型
      this.changeShowProductsType1('categories');
      this.changeShowProductsType2(null);
      this.changeShowProductsType3(null);
      let saveScroll = this.scroll;
      let id = item.ProductGroup_id;
      const group = this.allGroups.filter(group => group.ProductGroup_id === id)[0];
      if (this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if (this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          this.$router.push(`/collections/${group.Name.toLowerCase()}`);
          setTimeout(() => {
            document.documentElement.scrollTop = saveScroll;
          }, 500);
        } else {
          this.activeGroup = group.Name;
          this.fetchSelectedGroup(group.ProductGroup_id);
        }
      } else {
        this.$router.push(`/collections/${group.Name.toLowerCase()}`);
        setTimeout(() => {
          document.documentElement.scrollTop = saveScroll;
        }, 500);
      }
    },
    selectNewCategory(item) {
      this.activeCustomCategory = item.Name;
      this.list = [];
      const ctemp1 = [];
      const ctemp2 = [];
      const sortedData = item.Products.map((a) => {
        if (this.isOutOfStock(a)) {
          ctemp2.push(a)
        } else {
          ctemp1.push(a)
        }
      })
      this.catOut = ctemp2.sort((a, b) => {
        return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
      });
      this.catReg = ctemp1.sort((a, b) => {
        return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
      })
      this.list = this.catReg.concat(this.catOut);
    },
    toggleCustomCategories() {
      this.customCategoriesOpen = !this.customCategoriesOpen;
    },
    selectGroup(group) {
      this.activeGroup = group.Name;
      this.changeGroup(group)
      this.currentGroupId = group.ProductGroup_id;
      this.fetchSelectedGroup(group.ProductGroup_id)
    },
    fetchSelectedGroup(id, priceFilter) {
      this.currentGroupId = id;
      this.list = [];
      this.isLoading = true;
      this.fetchProductsWithGroupId({id,company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.isLoading = false;
          const temp1 = [];
          const temp2 = [];
          let sortedData = [];
          if (priceFilter) {
            sortedData = res.data.filter(item => item.Price <= priceFilter).map((a) => {
              if (this.isOutOfStock(a)) {
                temp2.push(a)
              } else {
                temp1.push(a)
              }
            });
          } else {
            sortedData = res.data.map((a) => {
              if (this.isOutOfStock(a)) {
                temp2.push(a)
              } else {
                temp1.push(a)
              }
            });
          }
          this.listOut = temp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.listReg = temp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          })
          this.list = this.listReg.concat(this.listOut);
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err)
        })
    },
    filterGroups(filter) {
      let list = this.list.slice();
      let sortedList = [];
      if (filter === 'sale') {
        sortedList = list.sort((a, b) => {
          return a.IsPromotion ? 1 : -1;
        })
      }
      if (filter === 'low') {
        sortedList = list.sort((a, b) => {
          return a.Price > b.Price ? 1 : -1;
        })
      }
      if (filter === 'high') {
        sortedList = list.sort((a, b) => {
          return a.Price < b.Price ? 1 : -1;
        })
      }
      this.list = sortedList
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function (item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
          .then(() => {
            flyToElement(event.target, $('.cart-link'));
          })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        flyToElement(event.target, $('.cart-link'));
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({path: '/productDetails', query: {productNum: product.ProductNum}})
    },
    changeGroup(group) {
      this.$router.push(`/collections/${group.Name.toLowerCase()}`)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            })
        })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
    activeCategory: state => state.products.activeCategory,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    itemCount: state => state.cart.itemCount,
    billboards: state => state.billboard.billboardImages,
    groups: state => state.navbar.allGroups,
    customCategories: state => state.products.customCategories,
    companyId: state => state.products.companyId,
    warehouseId: state => state.products.warehouseId,
  }),
  watch: {
    customCategories: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.activeCustomCategory = newVal[0].Name;
        this.selectNewCategory(newVal[0])
        this.categorySelected = [newVal[0].Name];
      }
    },
    categorySelected: function (newVal, oldVal) {
    }
  },
  mounted: function () {
    this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});

    window.addEventListener('scroll', this.handleScroll, true);
  }
}
</script>

<style lang="less">
@import "../assets/css/productList.less";
@import "../assets/css/public.less";

.rotate-enter-active .rotate-leave-active {
  transform: rotate(0.5turn);
}

.rotate {
  transform: rotateZ(180deg);
  transition: all 0.5s ease-out;
}

.rotate-back {
  transform: rotateZ(0);
  transition: all 0.5s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/view/homeProductList.vue